import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiGetRutas, getRoutesById, saveRoute } from "../api/rutasApi";

export const useRoute = () => {
  const [routes, setRoutes] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedRoutes, setSelectedRoutes] = useState(null);

  const [form, setForm] = useState({
    id: "",
    codigo: "",
    descripcion: "",
    estado: 1,
    orden: 0,
  });

  // ---- Load Routes ----
  const loadRoutes = async () => {
    try {
      const res = await apiGetRutas();
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);
      setRoutes(list);
    } catch {
      toast.error("fn loadRoutes: Error cargando rutas");
    }
  };

  // ---- Select Routes ----
  const loadRouteById = async (id) => {
    try {
      const res = await getRoutesById(id);

      if (!res.success) {
        toast.error("Ruta no encontrada");
        return;
      }

      const r = res.data;

      setForm({
        id: r.id,
        codigo: r.codigo || "",
        descripcion: r.descripcion || "",
        estado: r.estado || 0,
        orden: r.orden !== undefined && r.orden !== null ? r.orden : 0,
      });
    } catch {
      toast.error("fn loadRouteById: Error consultando ruta");
    }
  };

  const handleSelectRoutes = (id) => {
    setSelectedRoutes(id);
    loadRouteById(id);
  };

  // ---- New  ----
  const handleNew = () => {
    setSelectedRoutes(null);
    setForm({
      id: "",
      codigo: "",
      descripcion: "",
      estado: 1,
      orden: 0,
    });
  };

  // ---- Save  ----
  const saveRoutes = async () => {
    console.log(form);

    if (!form.codigo || !form.descripcion || !form.estado) {
      toast.error("Complete los campos obligatorios");
      return;
    }

    try {
      const res = await saveRoute(form);
      console.log(res);

      if (!res.success) {
        toast.error(res.message || "Error guardando ruta");
        return;
      }

      toast.success(res.message);
      loadRoutes();
      handleNew();
    } catch {
      toast.error("fn saveRoutes: Error guardando ruta");
    }
  };

  // Initial Load
  useEffect(() => {
    loadRoutes();
  }, []);

  return {
    routes,
    search,
    setSearch,
    selectedRoutes,
    form,
    setForm,
    handleNew,
    handleSelectRoutes,
    saveRoutes,
    loadRoutes,
  };
};
